import { ActiveOrderTableBodyType } from "../../../Type/Dashboard/CryptoDashboardType";
import { bitCoinChartData1, bitCoinChartData2, bitCoinChartData3, bitCoinChartData4, bitCoinChartData5, ethereumChartData, liteCoinChartData, totalEarningChartData } from "../DashboardCharts/DashboardCharts";

export const totalEarningData = [
    {
        icon:"bit-icon",
        class:"bit-icon",
        amount:"$20.790",
        color:"secondary",
        arrowIcon:"arrow-down",
        percentage:"- 36.28%",
        chart:totalEarningChartData
    },
    {
        icon:"ethereum",
        class:"ethereum-icon",
        amount:"$22.890",
        color:"success",
        arrowIcon:"arrow-up",
        percentage:"+ 23.28%",
        chart:ethereumChartData
    },
    {
        icon:"litecoin",
        class:"litecoin-icon",
        amount:"$12.180",
        color:"secondary",
        arrowIcon:"arrow-down",
        percentage:"- 36.28%",
        chart:liteCoinChartData
    }
]

export const livePricesTableData = [
    {
        icon:"bit-icon",
        title:"Bitcoin",
        coin:"BTC",
        amount:"$20,512",
        percentage: "+0,20%",
        chart:bitCoinChartData1
    },
    {
        icon:"ethereum",
        title:"Ethereum",
        coin:"ETH",
        amount:"$26,838",
        percentage: "-0,16%",
        chart:bitCoinChartData2
    },
    {
        icon:"monero",
        title:"Monero",
        coin:"XMR",
        amount:"$28,738",
        percentage: "+0,23%",
        chart:bitCoinChartData3
    },
    {
        icon:"litecoin",
        title:"Litecoin",
        coin:"LTC",
        amount:"$22,222",
        percentage: "-0,12%",
        chart:bitCoinChartData4
    },
    {
        icon:"bit-icon",
        title:"Bitcoin",
        coin:"BTC",
        amount:"$22,512",
        percentage: "+0,20%",
        chart:bitCoinChartData5
    }
]

export const recentContactData = [
    {
        image:"10.png",
        name:"Olivia",
        email:"@olivia"
    },
    {
        image:"11.png",
        name:"Gilbert",
        email:"@gilbert"
    },
    {
        image:"12.png",
        name:"Emma",
        email:"@emma"
    },
    {
        image:"13.png",
        name:"Helena",
        email:"@helena"
    },
    {
        image:"14.png",
        name:"Jessica",
        email:"@jessica"
    }
]

export const balanceLimit = [
    {
        class:"limit",
        percentage:"50%",
        title:'Main Limits',
        detail:"$200 / from $2000"
    },
    {
        class:"seconds",
        percentage:"74%",
        title:'Seconds',
        detail:"$500 / from $3000"
    },
]

export const popularCoinsTableBodyData = [
    {
        icon:"bit-icon",
        name:"Bitcoin BTC",
        price:"$40,651.64",
        perDay:"-0.02%",
        perWeek:"-0.02%",
        marketCap:"$512,651,64,954",
        volume:"$512,651,64",
        amount:"567,389 BTC"
    },
    {
        icon:"ethereum",
        name:"Ethereum ETH",
        price:"$20,651.45",
        perDay:"-4.33%",
        perWeek:"-4.33%",
        marketCap:"$651,695,15,156",
        volume:"$651,695,15",
        amount:"567,389 ETH"
    },
    {
        icon:"monero",
        name:"Monero XMR",
        price:"$92,365.02",
        perDay:"+0.01%",
        perWeek:"+0.01%",
        marketCap:"$952,354,65,951",
        volume:"$952,354,65",
        amount:"567,389 XMR"
    },
    {
        icon:"litecoin",
        name:"Litecoin LTC",
        price:"$91,365.21",
        perDay:"+9.80%",
        perWeek:"+9.80%",
        marketCap:"$951,561,12,698",
        volume:"$951,561,12",
        amount:"567,389 LTC"
    }
]

export const recentActivitiesBodyData = [
    {
        icon:"sent",
        name:"Sent LTC",
        productType:"To Coinbase",
        date:"May 5,2023",
        time:"01:08 PM",
        id:"6212",
        status:"70",
        color:"primary",
        volume:"0.00512 BTC",
        usd:"-220 USD"
    },
    {
        icon:"Buy",
        name:"Bought LTC",
        productType:"Using USD Account",
        date:"March 3,2023",
        time:"01:24 PM",
        id:"2512",
        status:"40",
        color:"secondary",
        volume:"0.00365 ETH",
        usd:"500 USD"
    },
    {
        icon:"download",
        name:"Received BTC",
        productType:"From Exodus",
        date:"Sep 8,2023",
        time:"05:32 PM",
        id:"9546",
        status:"70",
        color:"info",
        volume:"0.00956 BTC",
        usd:"500 USD"
    },
    {
        icon:"arrow-action",
        name:"Sent DOGE",
        productType:"To Binance",
        date:"May 5,2023",
        time:"23:90 PM",
        id:"3548",
        status:"40",
        color:"primary",
        volume:"0.00856 LTC",
        usd:"500 USD"
    }
]

export const activeOrderTableBody:ActiveOrderTableBodyType[] = [
    {
       date:"May 5,2023",
       time:"01:08 PM",
       button:"Buy",
       price:"12600.66",
       usd:"$ 7521.56",
       status:"Done" ,
       images:[
        "1.png","2.png","3.png"
       ]
    },
    {
        date:"March 23,2023",
        time:"01:24 PM",
        button:"Sell",
        price:"6513.85",
        usd:"$ 9512.12",
        status:"Pending" ,
        images:[
         "4.png","1.png","5.png"
        ]
     },
     {
        date:"Sep 14,2023",
        time:"05:32 PM",
        button:"Buy",
        price:"6591.85",
        usd:"$ 3215.41",
        status:"Done" ,
        images:[
         "6.png","7.png"
        ]
     },
     {
        date:"Jun 5,2023",
        time:"23:90 PM",
        button:"Sell",
        price:"9512.95",
        usd:"$ 9514.35",
        status:"In Progress" ,
        images:[
         "8.png","9.png","1.png"
        ]
     }
]
